import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CPResponse,
  MunicipalityResponse,
  NeighborhoodsResponse,
  StatesResponse,
} from './sepomex.response';
import { sepomexEndPoints } from './sepomex.end-points';

@Injectable({
  providedIn: 'root',
})
export class SepomexService {
  headers = {
    "api-key": 'da92864fb79a129cd7a4ea6d1af259375fe6c9854d9cd83e9c9c8933e6bd21ba',

  };

  urlSepomex= "https://api.s10plus.com/s10-sepomex.php"
  constructor(private http: HttpClient) {}

  listStates(): Observable<StatesResponse[]> {
    return this.http.get<StatesResponse[]>(this.urlSepomex + sepomexEndPoints.GET_ALL_STATES, {
      headers: this.headers,
    });
  }

  listMunicipality(state: number): Observable<MunicipalityResponse[]> {
    return this.http.get<MunicipalityResponse[]>(
      `${this.urlSepomex}${sepomexEndPoints.GET_ALL_MUNICIPALITY_X_STATES}${state}`,
      {
        headers: this.headers,
      }
    );
  }

  listNeighborhood(
    idMunicipality: number
  ): Observable<NeighborhoodsResponse[]> {
    return this.http.get<NeighborhoodsResponse[]>(
      `${this.urlSepomex}${sepomexEndPoints.GET_ALL_COLONY_X_STATES}${idMunicipality}`,
      {
        headers: this.headers,
      }
    );
  }

  searchForCP(cp: string): Observable<CPResponse> {
    return this.http.get<CPResponse>(
      `${this.urlSepomex}${sepomexEndPoints.SEARCH_FOR_CP}/${cp}`,
      {
        headers: this.headers,
      }
    );
  }
}
